module.exports = __webpack_public_path__ + "static/img/10015 (2).f060208.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10015 (2).webp
// module id = sMHi
// module chunks = 14